package com.wintermar.inspection.feature.domain.model.template

import com.wintermar.inspection.feature.domain.model.answer.AnswerModel
import com.wintermar.inspection.graphql.type.InspectionAnswerType

data class InspectionTemplateQuestionModel(
    val id: String = "",
    val sectionId: String = "",
    val questionText: String = "",
    val guidelines: String = "",
    val required: Boolean = false,
    val order: Int = 0,
    val answerType: InspectionAnswerType = InspectionAnswerType.UNKNOWN__,
    val failedOptionId: String = "",
    val neutralOptionId: String = "",
    val answerOptions: List<TemplateOptionModel> = emptyList(),
    val disabled: Boolean = false,
    val answer: AnswerModel = AnswerModel(),
) {
    fun setOptions(options: List<TemplateOptionModel>? = null): InspectionTemplateQuestionModel =
        this.copy(
            answerOptions = options
                ?.filter { answerType == it.answerType }
                ?.sortedBy { it.order }
                ?: emptyList()
        )

    fun getOption(id: String): TemplateOptionModel {
        return answerOptions.find { it.id == id } ?: TemplateOptionModel()
    }
}
